import { __decorate, __extends, __metadata } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
var KkCheckbox = /** @class */ (function (_super) {
    __extends(KkCheckbox, _super);
    function KkCheckbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KkCheckbox.prototype.changed = function () {
        var input = this.$refs.input;
        this.$emit("input", input.checked);
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], KkCheckbox.prototype, "value", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], KkCheckbox.prototype, "label", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], KkCheckbox.prototype, "disabled", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], KkCheckbox.prototype, "readonly", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], KkCheckbox.prototype, "required", void 0);
    __decorate([
        Prop({ default: true }),
        __metadata("design:type", Boolean)
    ], KkCheckbox.prototype, "labelSpace", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], KkCheckbox.prototype, "labelAsRawHtml", void 0);
    __decorate([
        Prop({ default: null }),
        __metadata("design:type", String)
    ], KkCheckbox.prototype, "tooltipText", void 0);
    KkCheckbox = __decorate([
        Component
    ], KkCheckbox);
    return KkCheckbox;
}(Vue));
export default KkCheckbox;
